import React from "react";
import MenuInner from "./MenuInner";

const MenuBar = ({ setMoveMenu }) => {
  return (
    <ul className="fixed bottom-0 left-0 right-0 z-50 flex w-full items-center justify-center border-t border-gray_40 bg-white safe-area-bottom">
      <div className="flex w-full max-w-[768px] items-center justify-between px-[20px] py-[10px]">
        <MenuInner setMoveMenu={setMoveMenu} />
      </div>
    </ul>
  );
};
export default MenuBar;
